const imagesData: any[] = [];

export default imagesData;
